import * as React from 'react';
interface Props {
  width: number,
  color: string,
  prev: string,
  mid: string,
  next: string,
}
const RankHeader: React.FC<Props> = props => (
  <ul
    style={{
      width: props.width + 'px',
      display: 'flex',
      color: props.color,
      fontSize: '14px',
      justifyContent: 'space-between',
      margin: '10px 0px 10px 0px',
    }}
  >
    <li>{props.prev}</li>
    <li>{props.mid}</li>
    <li>{props.next}</li>
  </ul>
)

export default RankHeader;